/**
 * @generated SignedSource<<c45ef63eae033504db1d832ba4b16cf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventChargeStaffControl = "ADMIN_ONLY" | "SELECTABLE";
export type EventMemberControl = "HIDDEN" | "SELECTABLE" | "VISIBLE";
import { FragmentRefs } from "relay-runtime";
export type useGetAllPrimaryChargeSelectionOptions_event$data = {
  readonly eligibleWindowsForCharges: ReadonlyArray<{
    readonly charges: {
      readonly edges: ReadonlyArray<{
        readonly memberControl: EventMemberControl;
        readonly node: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly displayDescription: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly id: string;
          };
          readonly id: string;
        } | null | undefined;
        readonly staffControl: EventChargeStaffControl;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly signUpWindows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly charges: {
          readonly edges: ReadonlyArray<{
            readonly memberControl: EventMemberControl;
            readonly node: {
              readonly chargeRuleSet: {
                readonly chargeRules: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly price: number;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly displayDescription: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly id: string;
              };
              readonly id: string;
            } | null | undefined;
            readonly staffControl: EventChargeStaffControl;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetAllPrimaryChargeSelectionOptions_event";
};
export type useGetAllPrimaryChargeSelectionOptions_event$key = {
  readonly " $data"?: useGetAllPrimaryChargeSelectionOptions_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetAllPrimaryChargeSelectionOptions_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventSignUpWindowChargesConnection",
    "kind": "LinkedField",
    "name": "charges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventSignUpWindowChargesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberControl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffControl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRegistrationChargeType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeRuleSet",
                "kind": "LinkedField",
                "name": "chargeRuleSet",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChargeRuleConnection",
                    "kind": "LinkedField",
                    "name": "chargeRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChargeRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChargeRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "price",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetAllPrimaryChargeSelectionOptions_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindowConnection",
      "kind": "LinkedField",
      "name": "signUpWindows",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindowEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUpWindow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "eligibleWindowsForCharges",
      "args": null,
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "7924fbfcd53a3f89e6ba35a2c4674559";

export default node;
